<template>
  <section v-if="this.organizations.length" class="mt-3">
<!--    <h3 class="text-left">-->
<!--      <span class="float-right" v-if="isOwner">-->
<!--        <router-link class="btn btn-md btn-dark" :to="{name: 'organizationAdd'}">Register a new organisation</router-link>-->
<!--      </span>-->
<!--    </h3>-->
    <div class="mb-3">
      <OrganizationsList v-bind:organizations="organizations" v-bind:type="type"/>
    </div>
    <div class="overflow-auto" v-if="showPagination">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.totalCount"
        :per-page="pagination.pageSize"
        first-text="First"
        prev-text="Prev"
        next-text="Next"
        last-text="Last"
        align="center"
        @input="getOrganizations"
        class="text-orange"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import OrganizationsList from './OrganizationsList'

export default {
  name: 'OrganizationSection',
  data () {
    return {
      organizations: [],
      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 8
      }
    }
  },
  props: {
    'type': String
  },
  components: {
    OrganizationsList
  },
  created () {
    // Load organizations only if user is logged in
    if (this.authenticatedUser) {
      this.getOrganizations()
    }
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ]),
    showPagination: function () {
      // display or not the pagination bar
      return this.pagination.totalCount > this.pagination.pageSize
    },
    organizationTitle: function () {
      // get the type of displayed organizations
      if (this.type === 'PUBLIC') {
        return 'Public Organizations'
      } else if (this.type === 'OWN') {
        return 'My Organizations'
      } // else if (this.type === 'SHARE') {
      // return 'Shared Organizations'
      // }
    },
    isOwner: function () {
      if (this.type === 'OWN') {
        return true
      } else if (this.type === 'PUBLIC') {
        return false
      } // else if (this.type === 'SHARE') {
      // return false
      // }
    }
  },
  methods: {
    initOrganizations: function () {
      this.organizations = []
    },
    getOrganizations: function () {
      // Fetch a list of organizations
      let params = {
        status: this.type,
        start: this.pagination.pageSize * (this.pagination.currentPage - 1),
        count: this.pagination.pageSize
      }
      // get data
      this.$store.dispatch('getOrganizationList', params).then(
        data => {
          this.pagination.totalCount = data.totalCount
          this.initOrganizations()
          this.organizations = data.results
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/organizations/OrganizationSection.vue